import axios from 'axios';

export const moduleNewAccount = {
	state() {
		return {
			myAccount: null,
			//Loader
			myAccountLoader: false,
			postMyAccountLoader: false,
		};
	},
	mutations: {
		setMyAccount(state, data) {
			state.myAccount = data;
		},

		setConfirmData(state, data) {
			state.myAccount.confirmData = data;
		},
		setCryptedPassword(state, data) {
			state.myAccount.cryptedPassword = data;
		},
		setCryptedPasswordConfirm(state, data) {
			state.myAccount.cryptedPasswordConfirm = data;
		},

		setMainAddressisNotNeccessary(state, data) {
			state.myAccount.mainAddress.isNotNeccessary = data;
		},
		setCorrespondanceisNotNeccessary(state, data) {
			state.myAccount.correspondAddress.isNotNeccessary = data;
		},

		//Loader
		setMyAccountLoader(state, data) {
			state.myAccountLoader = data;
		},
		setPostMyAccountLoader(state, data) {
			state.postMyAccountLoader = data;
		},
	},
	getters: {
		getMyAccount: (state) => state.myAccount,
		//Loader
		getMyAccountLoader: (state) => state.myAccountLoader,
		getPostMyAccountLoader: (state) => state.postMyAccountLoader,
	},
	actions: {
		fetchMyAccount({ commit, dispatch }) {
			commit('setMyAccountLoader', true);
			dispatch('newLogoutTime');
			axios
				.get('RegistrationInternal/OpenAccount')
				.then((response) => {
					commit('setMyAccount', response.data);
					commit('setMainAddressisNotNeccessary', true);
					commit('setCorrespondanceisNotNeccessary', true);
					commit('setConfirmData', true);
					commit('setMyAccountLoader', false);
				})
				.catch(() => {})
				.finally(() => {
					commit('setMyAccountLoader', false);
				});
		},
		postMyAccount({ state, commit, dispatch }) {
			commit('setGlobalErrorMessage', '');
			commit('setPostMyAccountLoader', true);
			dispatch('newLogoutTime');
			return new Promise((resolve, reject) => {
				axios
					.post('RegistrationInternal/OpenAccount', state.myAccount)
					.then(
						() => {
							resolve(true);
							commit('setPostMyAccountLoader', false);
						},
						(response) => {
							if (response.status == 400) {
								let errors = response.data.errors;
								let errorMessage = response.data;
								if (errors) {
									errorMessage = '';
									for (var key in errors) {
										var err = errors[key];
										errorMessage +=
											err.toString() + '<br/>';
									}
								}
								commit('setGlobalErrorMessage', errorMessage);

								window.scroll({
									top: 0,
									left: 0,
									behavior: 'smooth',
								});
							}
							commit('setPostMyAccountLoader', false);
							reject(response);
						}
					)
					.catch(() => {});
			});
		},
	},
};
